import { FiHelpCircle, FiChevronRight } from "react-icons/fi";
import "./commonqueries.css";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const faqs = [
  {
    question: "How to track commission?",
    answer:
      "You can track your commission from the dashboard under the earnings section. All approved commissions are updated in real-time.",
  },
  {
    question: "Lead qualification criteria",
    answer:
      "A lead is considered qualified when the client completes verification and meets the eligibility criteria defined by the company.",
  },
  {
    question: "Marketing asset request",
    answer:
      "You can request marketing assets by emailing the support team or using the Email Support page available in your dashboard.",
  },
  {
    question: "Payment processing timeline",
    answer:
      "Payments are processed within 5–7 working days after commission approval and are credited directly to your registered bank account.",
  },
];

const CommonQueries = () => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleQuery = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      <div className="section-header-row">
        <h3>Common Queries</h3>
        <span
          onClick={() => navigate("/supports/queries")}
          className="link"
        >
          View All FAQs →
        </span>
      </div>

      <div className="query-list">
        {faqs.map((q, i) => (
          <div className="query-item-wrapper" key={i}>
            <div
              className="query-item"
              onClick={() => toggleQuery(i)}
            >
              <div className="query-left">
                <FiHelpCircle className="query-icon" />
                <span>{q.question}</span>
              </div>

              <FiChevronRight
                className={`query-arrow ${
                  activeIndex === i ? "open" : ""
                }`}
              />
            </div>

            {activeIndex === i && (
              <div className="query-answer">
                {q.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default CommonQueries;
